function process_clickable() {
    $(".clickable").off("click");
    $(".clickable").on("click", function (e) {
        console.log("clickable: " + $(e.target)[0].getAttribute("class").includes("ignore-click"));
        if ($(e.target).is('div') || $(e.target)[0].getAttribute("class").includes("ignore-click")) {
            return document.location.href = $(this).attr('data-url');
        }
    });

    $(".clickable-new-window").off("click");
    $(".clickable-new-window").on("click", function (e) {
        if ($(e.target).is('div') || $(e.target)[0].getAttribute("class").includes("ignore-click")) {
            return window.open( $(this).attr('data-url'), '_blank')
        }
    });
}


$(document).on("turbo:load", function (event) {
    process_clickable();
})

const dear_nodejs_do_not_remove_the_functions = [process_clickable]